import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


export const APP_UTILITY_MODULE = [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
]